import React from "react";
import {
  FGrid,
  FButton,
  FTruncateText,
  FDialog,
  FGridItem,
} from "ferrum-design-system";
import {
  addClassToBodyTag,
  openTransactionOnExplorer,
} from "../../../../utils/helperFunctions";
import completedIcon from "../../../../assets/ms-new-images/icons/ms-btn-completed-icon.png";
import pendingIcon from "../../../../assets/ms-new-images/icons/ms-btn-pending-icon.png";
import failedIcon from "../../../../assets/ms-new-images/icons/ms-btn-failed-icon.png";
import arrowRightIcon from "../../../../assets/ms-new-images/icons/ms-arrow-right-icon.png";
import fiberEngineIcon from "../../../../assets/ms-new-images/icons/ms-fiber-engine-icon.png";
import swapIcon from "../../../../assets/img/switch-icon.svg";
// import hashIcon from "../../../../assets/ms-new-images/icons/hashicon.svg";
import ExplorerIcon from "../../../../assets/ms-new-images/icons/explorer-icon.svg";
import Big from "big.js";
import { DEFAULT_TOKEN_LOGO } from "../../../../utils/const.utils";

const MyTradesDetailDialog = ({
  showTransactionInfo,
  setShowTransactionInfo,
  selectedItem,
}: any) => {
  return (
    <FDialog
      size={"large"}
      variant="transaction-info"
      title="MultiSwap"
      show={showTransactionInfo}
      onHide={() => {
        addClassToBodyTag(false);
        setShowTransactionInfo(false);
      }}
      headerInfo={
        <div className="ms-transaction-info-dialog-header d-flex">
          {selectedItem?.status === "swapWithdrawCompleted" ? (
            <>
              <div className="f-mt--4 f-mr--5">MultiSwap</div>
              <div className="ml-auto">
                <FButton
                  className={`ms-transaction-buttons btn-completed f-mr--6`}
                  title={"Completed"}
                  outlined
                  prefix={
                    <img
                      width={"15px"}
                      className="f-mt--4"
                      src={completedIcon}
                      alt="completedIcon"
                    />
                  }
                />
              </div>
            </>
          ) : selectedItem?.status === "swapWithdrawPending" ? (
            <>
              <div className="f-mt--4">MultiSwap</div>
              <div className="ml-auto">
                <FButton
                  className={`ms-transaction-buttons btn-pending f-mr--6`}
                  title={"Withdraw Pending"}
                  outlined
                  prefix={
                    <img
                      width={"15px"}
                      className="f-mt--4"
                      src={pendingIcon}
                      alt="pendingIcon"
                    />
                  }
                />
              </div>
            </>
          ) : selectedItem?.status === "swapWithdrawGenerated" ? (
            <>
              <div className="f-mt--4">MultiSwap</div>
              <div className="ml-auto">
                <FButton
                  className={`ms-transaction-buttons btn-pending f-mr--6`}
                  title={"Withdraw Signature Generated"}
                  outlined
                  prefix={
                    <img
                      width={"15px"}
                      className="f-mt--4"
                      src={pendingIcon}
                      alt="pendingIcon"
                    />
                  }
                />
              </div>
            </>
          ) : selectedItem?.status === "swapWithdrawFailed" ? (
            <>
              <div className="f-mt--4">MultiSwap</div>
              <div className="ml-auto">
                <FButton
                  className={`ms-transaction-buttons btn-failed f-mr--6`}
                  title={"Withdraw Failed"}
                  outlined
                  prefix={
                    <img
                      width={"15px"}
                      className="f-mt--4"
                      src={failedIcon}
                      alt="failedIcon"
                    />
                  }
                />
              </div>
            </>
          ) : selectedItem?.status === "swapFailed" ? (
            <>
              <div className="f-mt--4">MultiSwap</div>
              <div className="ml-auto">
                <FButton
                  className={`ms-transaction-buttons btn-failed f-mr--6`}
                  title={"Swap Failed"}
                  outlined
                  prefix={
                    <img
                      width={"15px"}
                      className="f-mt--4"
                      src={failedIcon}
                      alt="failedIcon"
                    />
                  }
                />
              </div>
            </>
          ) : selectedItem?.status === "swapCompleted" ? (
            <>
              <div className="f-mt--4">MultiSwap</div>
              <div className="ml-auto">
                <FButton
                  className={`ms-transaction-buttons my-trade-btn-swapped f-mr--6`}
                  title={"Swapped"}
                  style={{
                    color: "black",
                  }}
                  outlined
                  prefix={
                    <img
                      width={"15px"}
                      className="f-mt--4"
                      src={completedIcon}
                      alt="completedIcon"
                    />
                  }
                />
              </div>
            </>
          ) : null}
        </div>
      }
    >
      <>
        <div className="ms-transaction-info ">
          <FGrid className="amount">
            <FGridItem size={[4, 4, 4]} className="to-info jc jc-center">
              <div>
                <div>
                  <span className="font-size-12">FROM:</span>
                </div>
                <div className="d-flex">
                  <img
                    className="f-m--3"
                    src={selectedItem?.sourceNetwork?.logo}
                    alt=""
                    width="30px"
                    height="30px"
                  />
                  <img
                    className="f-m--3"
                    src={
                      selectedItem?.sourceCabn?.currency?.logo ||
                      DEFAULT_TOKEN_LOGO
                    }
                    alt=""
                    width="30px"
                    height="30px"
                  />
                  <label className="f-m--3 font-size-26">
                    {Number(selectedItem?.sourceAmount).toFixed(2)}
                  </label>
                </div>
                <div className="d-flex jc jc-center">
                  <FTruncateText
                    className="font-size-10"
                    style={{ cursor: "text" }}
                    text={`${selectedItem?.receiveTransactionId}`}
                  />
                  <img
                    src={ExplorerIcon}
                    alt={"Explorer Icon"}
                    width="15px"
                    height="15PX"
                    style={{ marginLeft: "0.5rem" }}
                    className="cursor-pointer"
                    onClick={() =>
                      window.open(
                        openTransactionOnExplorer(
                          selectedItem?.sourceNetwork?.blockExplorerUrl,
                          selectedItem?.receiveTransactionId,
                          selectedItem?.sourceNetwork?.nameInLower
                        ),
                        "_blank"
                      )
                    }
                  />
                </div>
              </div>
            </FGridItem>

            <div className="f-mb-1">
              <img
                className="arrowRightIcon"
                src={arrowRightIcon}
                alt="arrowRightIcon"
              />
            </div>
            <FGridItem size={[4, 4, 4]} className="to-info jc jc-center">
              <div>
                <div>
                  <span className="font-size-12">TO:</span>
                </div>
                <div className="d-flex">
                  <img
                    className="f-m--3"
                    src={selectedItem?.destinationNetwork?.logo}
                    alt=""
                    width="30px"
                    height="30px"
                  />
                  <img
                    className="f-m--3"
                    src={
                      selectedItem?.destinationCabn?.currency?.logo ||
                      DEFAULT_TOKEN_LOGO
                    }
                    alt=""
                    width="30px"
                    height="30px"
                  />

                  <label className="f-m--3 font-size-26">
                    {Number(selectedItem?.destinationAmount).toFixed(2)}
                  </label>
                </div>
                <div className="d-flex jc jc-center">
                  <FTruncateText
                    className="font-size-10"
                    style={{ cursor: "text" }}
                    text={`${
                      selectedItem?.withdrawTransactions?.length
                        ? selectedItem?.withdrawTransactions[0]?.transactionId
                        : "N/A"
                    }`}
                  />
                  <img
                    src={ExplorerIcon}
                    alt={"Explorer Icon"}
                    width="15px"
                    height="15PX"
                    style={{ marginLeft: "0.5rem" }}
                    className="cursor-pointer"
                    onClick={() =>
                      window.open(
                        openTransactionOnExplorer(
                          selectedItem?.destinationNetwork?.blockExplorerUrl,
                          selectedItem?.withdrawTransactions[0]?.transactionId,
                          selectedItem?.destinationNetwork?.nameInLower
                        ),
                        "_blank"
                      )
                    }
                  />
                </div>
              </div>
            </FGridItem>
          </FGrid>

          <div className="ms-transaction-info-fiber-logo">
            <p className="d-flex jc jc-center f-pt-1">
              <img src={fiberEngineIcon} alt="fiberEngineIcon" />
            </p>
            <div className="ms-transaction-content">
              <div
                className="f-mt--8"
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                <div className="d-flex">
                  <p className="f-mr--8">
                    {selectedItem?.sourceAssetType} Asset
                  </p>
                  <img
                    // style={{ width: "20px" }}
                    src={selectedItem?.sourceNetwork?.logo}
                    alt=""
                  />
                </div>
                <img
                  // style={{ width: "20px" }}
                  src={swapIcon}
                  alt={"icon"}
                />
                <div className="d-flex">
                  <p className="f-mr--8">
                    {selectedItem?.destinationAssetType} Asset
                  </p>
                  <img
                    // style={{ width: "20px" }}
                    src={selectedItem?.destinationNetwork?.logo}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="ms-transaction-values f-mt-2 f-mb--4">
            <FGrid className={"ms-transaction-values-grid-style"}>
              <FGridItem
                size={[4, 4, 4]}
                className="jc jc-center f-mb--3 f-mt--3"
              >
                <span className="entity">
                  Platform Fee: <span className="value">TBD</span>
                </span>
              </FGridItem>
              <FGridItem
                size={[4, 4, 4]}
                className="jc jc-center f-mb--3 f-mt--3"
              >
                <span className="entity">
                  Gas Fee:{" "}
                  <span className="value">
                    {selectedItem?.gasPrices?.source?.gasPrice
                      ? new Big(
                          Number(selectedItem?.gasPrices?.source?.gasPrice)
                        )
                          .add(
                            Number(
                              selectedItem?.gasPrices?.destination?.gasPrice
                            )
                          )
                          .toFixed(8)
                      : "0.0"}{" "}
                  </span>
                </span>
              </FGridItem>
              <FGridItem
                size={[4, 4, 4]}
                className="jc jc-center f-mb--3 f-mt--3"
              >
                <span className="entity">
                  Minimum received:{" "}
                  <span className="value">
                    {Number(selectedItem?.destinationAmount).toFixed(5)}
                  </span>
                </span>
              </FGridItem>
            </FGrid>
          </div>
        </div>
      </>
    </FDialog>
  );
};

export default MyTradesDetailDialog;
